"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_ROLE_TYPES = exports.UserRoleTypeSchema = exports.UserRoleTypeIterable = exports.UserTypeSchema = exports.UserTypeIterable = exports.BaseOrganizationSchema = exports.OrganizationTypeSchema = exports.OrganizationTypeIterable = void 0;
/**
 * Shared Organization types
 *
 * This file contains base organization types that are used by multiple files
 * to avoid circular dependencies. These types should NOT import from:
 * - DbTables.ts
 * - Organization.ts
 * - Report.ts
 */
const zod_1 = require("zod");
// ============================================================================
// ORGANIZATION TYPE SCHEMA
// ============================================================================
// NOTE: This enum must be kept in sync with Organization.OrganizationType
// The enum is duplicated here to avoid circular dependency issues
exports.OrganizationTypeIterable = [
    'adminAgent',
    'backupServicer',
    'borrower',
    'capitalProvider',
    'capitalProviderRepresentative',
    'collectionAccountBank',
    'payingAgent',
    'servicer',
    'special',
    'verificationAgent',
];
exports.OrganizationTypeSchema = zod_1.z.enum(exports.OrganizationTypeIterable);
// ============================================================================
// BASE ORGANIZATION SCHEMA
// ============================================================================
/**
 * Minimal set of organization properties that are exposed to other
 * organizations on an allowlist basis.
 */
exports.BaseOrganizationSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    slug: zod_1.z.string(),
});
// ============================================================================
// USER TYPE SCHEMA
// ============================================================================
exports.UserTypeIterable = [
    'ANALYTICS',
    'BACKUP_LENDER',
    'BACKUP_ORIGINATOR',
    'BORROWER',
    'CAPITAL_PROVIDER',
    'SUPER_USER',
];
exports.UserTypeSchema = zod_1.z.enum(exports.UserTypeIterable);
// ============================================================================
// USER ROLE TYPE SCHEMA
// ============================================================================
exports.UserRoleTypeIterable = ['ADMIN', 'MEMBER', 'CONTRIBUTOR'];
exports.UserRoleTypeSchema = zod_1.z.enum(exports.UserRoleTypeIterable);
exports.USER_ROLE_TYPES = [
    'ADMIN',
    'MEMBER',
    'CONTRIBUTOR',
];
//# sourceMappingURL=SharedOrganization.js.map